/**
 * Centralized z-index scale for the application
 * Each layer is 10 units apart to allow for micro-adjustments
 */
export const Z_INDEX = {
  NAV: 10,
  TABLE_STICKY: 20,
  MODAL_BASE: 50,
  MODAL_NESTED: 60,
  MODAL_NESTED_2: 70,
  DROPDOWN: 80,
  TOOLTIP: 100,
  NOTIFICATION: 200, // Notifications/toasts appear above everything
} as const

/**
 * Calculate z-index for nested modals
 * @param depth - Modal nesting depth (0 = base modal, 1 = first nested, etc)
 */
export const getModalZIndex = (depth: number = 0): number => {
  return Z_INDEX.MODAL_BASE + depth * 10
}

/**
 * Calculate z-index for dropdowns inside modals
 * Always 30 units above the current modal layer
 */
export const getDropdownZIndex = (modalDepth: number = 0): number => {
  return getModalZIndex(modalDepth) + 30
}
